<template>
  <div class="resident-nursing-note">
    <b-modal
      no-close-on-backdrop
      hide-footer
      id="popupTypeCreate"
      title="ADICIONAR SINAIS VITAIS (SSVV)"
      size="md"
    >
      <Create
        :rest_home_id="rest_home_id"
        :resident_id="resident_id"
        :user_id="user.id"
        :type="type"
        :open="true"
        v-on:popup="handlePopup"
        v-on:created="paginate"
      />
    </b-modal>
    <b-modal
      no-close-on-backdrop
      centered
      hide-header-close
      hide-footer
      id="modalFilter"
      title="FILTRAR"
    >
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <h6 class="worksansr upper-text">Status</h6>
          <select v-model="status" class="form-control">
            <option value="A">EM ABERTO</option>
            <option value="F">FINALIZADOS</option>
            <option value="ALL">TODOS</option>
          </select>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <h6 class="worksansr upper-text">data inicial</h6>
          <input type="date" v-model="dtInit" class="form-control" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0">
          <h6 class="worksansr upper-text">data final</h6>
          <input type="date" v-model="dtEnd" class="form-control" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <b-button class="btn-cancel m-1" @click="$bvModal.hide('modalFilter')"
            >CANCELAR</b-button
          >
          <v-btn class="btn-filter-sidebar float-right" @click="paginate">
            <i class="fas fa-filter mr-2 text-twenty"></i>
            FILTRAR
          </v-btn>
        </div>
      </div>
    </b-modal>
    <div class="row" v-if="$store.state.online">
      <div class="col-xl-6 col-lg-6 col-md-5 col-sm-5 col-12 pb-0">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="Pesquisar sinais vitais"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          @input="paginate"
        />
      </div>
      <div class="col-xl-6 col-lg-6 col-md-7 col-sm-7 col-12 text-right">
        <v-btn
          class="btn-filter mt-2 mr-2"
          @click="$bvModal.show('modalFilter')"
        >
          <i
            :class="[
              'fas fa-filter text-twenty',
              width < 600 ? 'mr-0 ' : 'mr-2',
            ]"
          ></i>
          <span v-if="width > 600">FILTRAR</span>
        </v-btn>
        <v-btn
          v-if="permission('write', 'resident_vital_signs')"
          class="btn-add mt-2"
          v-on:click="handleModalCreate"
        >
          <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
        </v-btn>
      </div>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="v-clean p-5 text-center" v-show="cares.length == 0">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <v-data-table
        v-show="cares.length > 0"
        dense
        :headers="headers"
        :items="cares"
        :search="search"
        item-key="id"
        :options.sync="options"
        :server-items-length="total"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        @click:row="handleClickRowTable"
      >
        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}</template
        >
        <template v-slot:[`item.pending_vital_signs`]="{ item }">
          <div>
            <h6
              :class="[
                'mb-0 worksansr',
                'text-success',
                item.typeItem == 'CARE' && item.status == 'A' && 'text-warning',
                item.typeItem == 'VITAL_SIGN' &&
                  item.pending_vital_signs > 0 &&
                  'text-warning',
              ]"
            >
              {{
                item.typeItem == "CARE" && item.status == "A"
                  ? "EM ABERTO"
                  : item.typeItem == "CARE"
                  ? "FINALIZADO"
                  : item.typeItem == "VITAL_SIGN" &&
                    item.pending_vital_signs > 0
                  ? "EM ABERTO"
                  : "FINALIZADO"
              }}
            </h6>
          </div>
        </template>
      </v-data-table>
    </b-overlay>
  </div>
</template>

<script>
import Create from "../../../templates/Care/NursingCaregiver/Create/Single/VitalSigns";

import api from "../../../services/api";

import moment from "moment";

import { formatDate } from "../../../lib/format";

import routes from "../../../routes";

import { userData, getStatic } from "../../../lib/functions";

import permission from "../../../lib/permission";

export default {
  name: "VitalSigns",
  components: {
    Create,
  },
  data() {
    return {
      accessed_offline: false,
      status: "ALL",
      search: "",
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 25,
      },
      headers: [
        { text: "CRIADO POR", value: "user_name" },
        { text: "DATA CADASTRO", value: "created_at" },
        { text: "SITUAÇÃO", value: "pending_vital_signs" },
      ],
      rest_home_id: "",
      resident_id: "",
      type: "CUIDADOR_ENFERMAGEM",
      show: "CUIDADOR_ENFERMAGEM",
      permissions: {},
      user: {},
      cares: [],
      width: window.screen.width,
      dtInit: moment().subtract(3, "days").format("YYYY-MM-DD"),
      dtEnd: moment().format("YYYY-MM-DD"),
      loading: true,
      errors: [],
    };
  },
  created() {
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },
  watch: {
    options: {
      handler() {
        this.retrieve();
      },
    },
  },
  methods: {
    permission,
    formatDate,
    moment,
    handleOnResize() {
      this.width = window.innerWidth;
    },
    handlePopup() {
      this.$bvModal.hide("popupTypeCreate");
    },
    handleClickRowTable({ id }) {
      routes.push({ name: "vital_sign", params: { id } });
    },
    handleChangeType({ target: { value } }) {
      this.show = value;
    },
    handleType(type) {
      var show = {
        CUIDADOR_ENFERMAGEM: "CUIDADOR/ENFERMAGEM",
        ENFERMEIRA: "ENFERMEIRA",
        MEDICO: "MÉDICO",
        EQUIPE_MULTIDISCIPLINAR: "EQUIPE MULTIDISCIPLINAR",
        default: "TIPO NÃO ENCONTRADO!",
      };

      return show[type] || show.default;
    },
    async retrieve() {
      const { user, permissions } = userData();

      this.rest_home_id = user.rest_home_id;

      this.permissions = permissions;

      this.user = user;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { date } = routes.history.current.query;

      if (date) {
        this.dtInit = date;
        this.dtEnd = date;
      }

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      this.accessed_offline = accessed_offline;

      if (accessed_offline) {
        try {
          let residents = (
            await getStatic("/offline/residents/vital-signs", true)
          ).residents;

          let resident = residents.filter((item) => item.id == id);

          if (resident[0]) {
            let { vitalSigns } = resident[0];

            this.cares = vitalSigns;
            this.total = vitalSigns.length;
          }
        } catch (errors) {
          this.errors = errors;
        }
        this.loading = false;
      } else {
        await this.paginate();
      }
    },
    async paginate() {
      try {
        this.$bvModal.hide("modalFilter");
        this.loading = true;

        const { page, itemsPerPage } = this.options;

        const { search, resident_id, rest_home_id, dtInit, dtEnd, status } =
          this;

        const response = await api.get(
          "/rest-home/care-vital-signs/resident/get",
          {
            params: {
              search,
              resident_id,
              rest_home_id,
              dtInit,
              dtEnd,
              page,
              itemsPerPage,
              status,
            },
          }
        );

        const { cares, total, error } = response.data;

        if (error) {
          return routes.push({ name: "cares2" });
        }

        this.cares = cares;
        this.total = total;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.$bvModal.show("popupTypeCreate");
      this.type = "CUIDADOR_ENFERMAGEM";
      this.show = "CUIDADOR_ENFERMAGEM";
      this.errors = [];
    },
  },
};
</script>
